import { render } from "./MineClosure.vue?vue&type=template&id=5af2106e&scoped=true"
import script from "./MineClosure.vue?vue&type=script&lang=js"
export * from "./MineClosure.vue?vue&type=script&lang=js"

import "./MineClosure.vue?vue&type=style&index=0&id=5af2106e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af2106e"]])

export default __exports__